<page-toolbar [title]="title" [pageActions]="pageActions"></page-toolbar>

<page-content *ngIf="organisationId">
  <ng-container [ngSwitch]="type">
    <addressbook-edit-form *ngSwitchCase="'addressbooks'" [organisationId]="organisationId" [itemId]="itemId"
                  (changed)="hasChanged = $event" #editForm></addressbook-edit-form>
    <group-edit-form *ngSwitchCase="'groups'" [organisationId]="organisationId" [itemId]="itemId"
                  (changed)="hasChanged = $event" #editForm></group-edit-form>
    <frontendgroup-edit-form *ngSwitchCase="'frontend-groups'" [organisationId]="organisationId" [itemId]="itemId"
                  (changed)="hasChanged = $event" #editForm></frontendgroup-edit-form>
    <profile-edit-form *ngSwitchCase="'profiles'" [organisationId]="organisationId" [itemId]="itemId"
                  (changed)="hasChanged = $event" #editForm></profile-edit-form>
    <frontendprofile-edit-form *ngSwitchCase="'frontend-profiles'" [organisationId]="organisationId" [itemId]="itemId"
                  (changed)="hasChanged = $event" #editForm></frontendprofile-edit-form>
  </ng-container>
</page-content>
